import { Divider } from 'antd';
import { StyledInfoCircleFilled } from 'App.styles';
import { useMemo } from 'react';
import { colors } from 'theme';
import useDeclarations from 'hooks/useDeclarations';
import useGetDeclarationMapValues from 'hooks/useGetDeclarationMapValues';
import useProducts from 'hooks/useProducts';
import {
    missingGrossMassFromMaster,
    missingGrossMassFromAllItems,
} from 'views/declarations/declaration-tabs/declaration-form/utils/grossMassUtils';
import { getDeclarationPayload } from 'views/declarations/utils/declaration-utils';

const GrossMassSumInfo = () => {
    const { declaration } = useDeclarations();
    const mapper = useGetDeclarationMapValues();
    const { products } = useProducts();

    const show = useMemo(() => {
        const grossMassMasterMissing = missingGrossMassFromMaster(
            getDeclarationPayload(declaration),
            mapper.grossMassPath
        );
        const grossMassAllItemsMissing = missingGrossMassFromAllItems(products?.list, mapper.itemGrossMassPath);

        return grossMassMasterMissing && !grossMassAllItemsMissing;
    }, [declaration, mapper.grossMassPath, mapper.itemGrossMassPath, products?.list]);

    if (!show) return null;

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    <div style={{ display: 'flex', gap: '12px' }}>
                        <StyledInfoCircleFilled color="warning" style={{ color: 'orange', margin: 0 }} />
                        <h3 style={{ margin: 0 }}>Gross mass</h3>
                    </div>
                    <p style={{ margin: 0, fontSize: '1.25rem', color: colors.darkGrey }}>
                        We will sum the gross mass of all items and populate the master gross mass field with it.
                    </p>
                </div>
            </div>
            <Divider />
        </>
    );
};

export default GrossMassSumInfo;
